module.exports = __webpack_public_path__ + "img/task_setting2.3c37bc21.png";